import { zodResolver } from "@hookform/resolvers/zod"
import { useEffect } from "react"
import { useForm } from "react-hook-form"
import { CustomerResponseDataSchema, UpsertCustomerBodySchema } from "schema"
import { z } from "zod"
import { BaseCustomerForm } from "./BaseCustomerForm"

type TypeUpsertCustomerBody = z.infer<typeof UpsertCustomerBodySchema>

type CustomerFormProps = {
  customer?: Omit<z.infer<typeof CustomerResponseDataSchema>, "client">
  onSubmit: (data: TypeUpsertCustomerBody) => void
  submitCopy: string
}

export const CustomerForm = ({ customer, onSubmit, submitCopy }: CustomerFormProps) => {
  const form = useForm<TypeUpsertCustomerBody>({
    resolver: zodResolver(UpsertCustomerBodySchema),
    defaultValues: {},
  })

  useEffect(() => {
    if (customer) {
      form.reset(customer)
    }
  }, [customer, form])

  return <BaseCustomerForm form={form} onSubmit={onSubmit} submitCopy={submitCopy} />
}
